export default function MurfreesboroFinalCTA() {
  return (
    <section id="contact" className="relative bg-[#1A365D] py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Nashville%20Tennessee%20skyline%20at%20golden%20hour%20sunset%20with%20Cumberland%20River%20reflections%2C%20warm%20amber%20and%20orange%20tones%2C%20cinematic%20aerial%20photography%20with%20professional%20editorial%20quality%20and%20clear%20sky&width=1600&height=600&seq=murfreesboro-cta-bg&orientation=landscape"
          alt="Nashville Tennessee"
          className="w-full h-full object-cover opacity-10"
        />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#F6C344]/20 text-[#F6C344] text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full mb-6">
          <i className="ri-graduation-cap-line"></i>
          MTSU Student &amp; Nashville Metro Specialist
        </div>

        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
          Don't Let a Passport
          <span className="text-[#F6C344]"> Miss Your Semester</span>
        </h2>

        <p className="text-white/70 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          Whether it's an MTSU study abroad deadline, a corporate trip for Nissan, or a family vacation — we have your passport ready when you need it. Murfreesboro's fastest passport processing service, trusted by Middle Tennessee families.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="tel:+18001234567"
            className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-bold px-10 py-4 rounded-lg hover:bg-[#e5b33f] transition-all text-lg whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Call for Emergency Service
          </a>
          <a
            href="#how-it-works"
            className="inline-flex items-center gap-2 border-2 border-white/30 text-white font-semibold px-8 py-4 rounded-lg hover:border-white/60 hover:bg-white/10 transition-all whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            Back to Top
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
          {[
            { label: "Emergency", value: "24hr" },
            { label: "Students Served", value: "800+" },
            { label: "Miles to Nashville", value: "35" },
            { label: "Satisfaction", value: "100%" },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="font-serif text-3xl font-bold text-[#F6C344] mb-1">{stat.value}</div>
              <div className="text-white/60 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}